// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__26vKH","item":"PaymentsMobile_item__3BBRV","label":"PaymentsMobile_label__2pfqy","amount":"PaymentsMobile_amount__3HUxO"};